const dev = {
  appKey: "c20eba396cb11890c4bd081c54120219",
  aesKey: "xljC7sTIYWQ1MzM2MGMxNWY2NWQ4NzlkNDBjMzdmNzMwNzQ5Y2I=3GU8Ca7D",
  encData: false,
  VUE_APP_ISWECHAT:''
}
// 测试
// const pro = {
//   appKey: "c20eba396cb11890c4bd081c54120219",
//   aesKey: "xljC7sTIYWQ1MzM2MGMxNWY2NWQ4NzlkNDBjMzdmNzMwNzQ5Y2I=3GU8Ca7D",
//   encData: false,
// VUE_APP_ISWECHAT:'text'
// }
// 生产
const pro = {
  appKey: "e9000019a471da947b9c3d3b94a2edc1",
  aesKey: "VOPgaUezYjM2ZGRkZjA1MzMxMGRlYzJlMWE2N2E3NmFhODdlOTg=PFH9JY0e",
  encData: false,
  VUE_APP_ISWECHAT:'text'
}

// export default process.env.VUE_APP_RUN_DEV ? dev : pro;
export default process.env.VUE_APP_RUN_DEV ? pro : pro;